export const environment = {
  // url: 'https://dev-api-machine.credebt.com/', //Cred dev url
  intermediaryUrl: 'https://dev-api-intermediary.credebt.com/', //Intermediary dev url
  clientId: '0842a616-1d3e-4b72-a76b-bc4db2954dc5',
  authority: 'https://login.microsoftonline.com/7653f2c8-b98b-4cb3-8f2d-4e0b7c7a9e4b',
  TimeOut: 300,
  Idle: 1500,
};
